import React from 'react';
import { Button } from './ui/button';
import { Check, Pencil, X, ArrowUpRight } from 'lucide-react';
import StatusPill from './StatusPill';

// Human-in-the-loop action bar. When status is resolved, shows the outcome.
export default function HITLBar({
  status = 'awaiting_review',
  approveLabel = 'Approve',
  onApprove, onEdit, onReject, onEscalate,
  compact = false,
}) {
  if (status && status !== 'awaiting_review') {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <StatusPill status={status} />
        <span className="text-xs">Resolved</span>
      </div>
    );
  }
  const size = compact ? 'sm' : 'default';
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button size={size} className="bg-brand-600 hover:bg-brand-700 text-white" onClick={onApprove}>
        <Check className="h-4 w-4 mr-1.5" />{approveLabel}
      </Button>
      {onEdit && (
        <Button size={size} variant="outline" onClick={onEdit}>
          <Pencil className="h-4 w-4 mr-1.5" />Edit
        </Button>
      )}
      {onEscalate && (
        <Button size={size} variant="outline" onClick={onEscalate}>
          <ArrowUpRight className="h-4 w-4 mr-1.5" />Escalate
        </Button>
      )}
      {onReject && (
        <Button size={size} variant="ghost" className="text-slate-500 hover:text-rose-600" onClick={onReject}>
          <X className="h-4 w-4 mr-1.5" />Dismiss
        </Button>
      )}
    </div>
  );
}
